import React, { useRef, useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import LogsReportModal from './LogsReports';
import { _axios } from '../../utils/axios';

const ENTITY_TYPES = [
    { value: 'TEMPLE', label: 'Temples' },
    { value: 'TEERTHA', label: 'Teerthas' },
    { value: 'DEITY', label: 'Deities' },
    { value: 'SAINT', label: 'Saints' },
    { value: 'PARIKRAMA', label: 'Parikramas' },
    { value: 'PROJECT', label: 'Projects' }
];

const EditNotification = ({ show, onHide, templateData }) => {
    const [formData, setFormData] = useState({
        languages: { english: true, hindi: false, marathi: false, gujurati: false },
        titles: { english: '', hindi: '', marathi: '', gujurati: '' },
        descriptions: { english: '', hindi: '', marathi: '', gujurati: '' },
        status: '',
        action_link: '',
        thumbnail_url: '',
        audience_selection: 'All',
        platform_targets: [],
        activity_range: '',
        favourite_entity_type: '',
        favourite_entity_id: '',
        favourite_entity_name: '',
        isAutoScheduled: false,
        scheduledDate: '',
        scheduledTime: ''
    });
    const [entitySearchInput, setEntitySearchInput] = useState('');
    const [entitySearchResults, setEntitySearchResults] = useState([]);
    const searchTimerRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [stats, setStats] = useState({});
    const [targetUser, setTargetUser] = useState(0);
    const [showLogs, setShowLogs] = useState(false);

    const fetchStats = async () => {
        try {
            const { data } = await _axios.get(`${ServerPath}/admin-notification/stats`);
            if (data.success === 1) {
                setStats(data.data);
            }
        } catch (err) { console.error(err); }
    };

    useEffect(() => { if (show) fetchStats(); }, [show]);

    // Initialize form with multi-language data from templateData
    useEffect(() => {
        console.log('template data', templateData);
        if (templateData && show) {
            let selection = 'All';
            let platforms = [];
            let activity = '';

            if (templateData.audience_type.includes('Activity-')) {
                selection = 'Activity';
                activity = templateData.audience_type.split('-')[1];
            } else if (templateData.audience_type === 'Favourite') {
                selection = 'Favourite';
            } else if (templateData.audience_type === 'iOS' || templateData.audience_type === 'Android' || templateData.audience_type.includes(',')) {
                selection = 'Platform';
                platforms = templateData.audience_type.split(',');
            }

            // Split scheduled_at into Date and Time
            // let sDate = '';
            // let sTime = '';
            // if (templateData.scheduled_at) {
            //     const dt = new Date(templateData.scheduled_at);
            //     sDate = dt.toISOString().split('T')[0];
            //     sTime = dt.toTimeString().split(' ')[0].substring(0, 5);
            // }
            let sDate = '';
            let sTime = '';

            if (templateData.scheduled_at) {
                const parts = templateData.scheduled_at.replace('T', ' ').split(' ');

                if (parts.length >= 2) {
                    sDate = parts[0];
                    sTime = parts[1].slice(0, 5);
                }
            }

            const favType = templateData.favourite_entity_type || '';
            const favId = templateData.favourite_entity_id || '';
            const favName = templateData.favourite_entity_name || '';

            setFormData({
                languages: {
                    english: !!templateData.title,
                    hindi: !!templateData.title_hin,
                    marathi: !!templateData.title_mar,
                    gujurati: !!templateData.title_guj
                },
                titles: {
                    english: templateData.title || '',
                    hindi: templateData.title_hin || '',
                    marathi: templateData.title_mar || '',
                    gujurati: templateData.title_guj || ''
                },
                descriptions: {
                    english: templateData.body || '',
                    hindi: templateData.body_hin || '',
                    marathi: templateData.body_mar || '',
                    gujurati: templateData.body_guj || ''
                },
                action_link: templateData.deep_link || '',
                thumbnail_url: templateData.image_url || '',
                status: templateData.status || 'Draft',
                audience_selection: selection,
                platform_targets: platforms,
                activity_range: activity,
                favourite_entity_type: favType,
                favourite_entity_id: favId,
                favourite_entity_name: favName,
                isAutoScheduled: !!templateData.is_scheduled,
                scheduledDate: sDate,
                scheduledTime: sTime
            });
            setTargetUser(templateData?.target_user || 0);
        }
    }, [templateData, show]);
    
    const handleInputChange = (e, category, lang) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => {
            if (type === 'checkbox' && category === 'languages') {
                return { ...prev, languages: { ...prev.languages, [name]: checked } };
            }
            if (category) {
                return { ...prev, [category]: { ...prev[category], [lang]: value } };
            }
            if (type === 'checkbox' && name === 'platform') {
                const platforms = prev.platform_targets.includes(value)
                    ? prev.platform_targets.filter(p => p !== value)
                    : [...prev.platform_targets, value];
                return { ...prev, platform_targets: platforms };
            }
            return { ...prev, [name]: value };
        });
    };

    const fetchEntityResults = (type, query) => {
        if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
        searchTimerRef.current = setTimeout(async () => {
            try {
                const { data } = await _axios.get(`${ServerPath}/admin-notification/favourite-entities`, {
                    params: { type, search: query || '', limit: 20 }
                });
                if (data.success === 1) setEntitySearchResults(data.data || []);
                else setEntitySearchResults([]);
            } catch (err) {
                console.error('Entity search error:', err);
                setEntitySearchResults([]);
            }
        }, 300);
    };

    const handleEntityTypeChange = (e) => {
        const newType = e.target.value;
        setFormData(prev => ({
            ...prev,
            favourite_entity_type: newType,
            favourite_entity_id: '',
            favourite_entity_name: ''
        }));
        setEntitySearchInput('');
        setEntitySearchResults([]);
        setTargetUser(0);
    };

    const handleEntitySearchChange = (e) => {
        const value = e.target.value;
        setEntitySearchInput(value);
        if (!formData.favourite_entity_type) return;
        fetchEntityResults(formData.favourite_entity_type, value);
    };

    const handleEntitySelect = (entity) => {
        setFormData(prev => ({
            ...prev,
            favourite_entity_id: entity.entity_id,
            favourite_entity_name: entity.name
        }));
        setTargetUser(entity.favourite_user_count ?? 0);
        setEntitySearchInput('');
        setEntitySearchResults([]);
    };

    const handleEntityRemove = () => {
        setFormData(prev => ({ ...prev, favourite_entity_id: '', favourite_entity_name: '' }));
        setTargetUser(0);
    };

 const handleSubmit = async (finalStatus) => {
    // 1. Dynamic Validation for Selected Languages
    const selectedLanguages = Object.keys(formData.languages).filter(lang => formData.languages[lang]);

    if (selectedLanguages.length === 0) {
        return toast.error("Please select at least one language");
    }

    for (const lang of selectedLanguages) {
        const title = formData.titles[lang];
        const description = formData.descriptions[lang];

        if (!title || !description) {
            const langLabel = lang.charAt(0).toUpperCase() + lang.slice(1);
            return toast.error(`${langLabel} Title and Description are required`);
        }
    }

        if (!formData.action_link) {
            return toast.error("Action Link is required");
        }

        if (formData.audience_selection === 'Favourite') {
            if (!formData.favourite_entity_type) return toast.error("Please select an entity type");
            if (!formData.favourite_entity_id) return toast.error("Please select an entity");
        }

        if (templateData.status === 'Published' || templateData.status === 'Success') {
            return toast.error("Published notifications cannot be modified.");
        }

        let audienceType = formData.audience_selection;
        if (formData.audience_selection === 'Platform') {
            audienceType = formData.platform_targets.join(',');
        } else if (formData.audience_selection === 'Activity') {
            audienceType = `Activity-${formData.activity_range}`;
        } else if (formData.audience_selection === 'Favourite') {
            audienceType = 'Favourite';
        }

        try {
            setIsLoading(true);

            // Helper to nullify values if the language checkbox is NOT selected
            const getVal = (category, lang) => formData.languages[lang] ? formData[category][lang] : null;

            const payload = {
                notification_id: templateData.notification_id,
                // Suffixes updated to match your backend service
                title: getVal('titles', 'english'),
                title_hin: getVal('titles', 'hindi'),
                title_mar: getVal('titles', 'marathi'),
                title_guj: getVal('titles', 'gujarati'), // Corrected spelling

                body: getVal('descriptions', 'english'),
                body_hin: getVal('descriptions', 'hindi'),
                body_mar: getVal('descriptions', 'marathi'),
                body_guj: getVal('descriptions', 'gujarati'), // Corrected spelling

                action_link: formData.action_link,
                image_url: formData.thumbnail_url,
                audience_type: audienceType,
                favourite_entity_type: formData.audience_selection === 'Favourite' ? formData.favourite_entity_type : null,
                favourite_entity_id: formData.audience_selection === 'Favourite' ? formData.favourite_entity_id : null,
                status: finalStatus,
                is_scheduled: formData.isAutoScheduled ? 1 : 0,
                scheduled_at: formData.isAutoScheduled ? `${formData.scheduledDate} ${formData.scheduledTime}:00` : null,
                target_user: targetUser
            };

            const res = await _axios.patch(`${ServerPath}/admin-notification`, payload);
            if (res.data.success) {
                toast.success(`Notification updated successfully`);
                onHide();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error updating notification");
        } finally { setIsLoading(false); }
    };
    const isViewOnly = templateData.status === 'Published' || templateData.status === 'Success';

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            <Modal.Header closeButton className="border-0" style={{ justifyContent: "space-between" }}>
                <Modal.Title className="fw-bold">Edit Notification Template</Modal.Title>
                {isViewOnly && <Button variant="secondary" style={{ marginRight: 100, color: 'black' }} onClick={() => setShowLogs(true)}>Logs Reports</Button>}
            </Modal.Header>
            <Modal.Body className="px-4">
                {/* 1. Languages & Status */}
                <Row className="mb-4">
                    <Col md={8}>
                        <Form.Label className="fw-semibold">Languages</Form.Label>
                        <div className="d-flex gap-4">
                            {['English', 'Hindi', 'Marathi', 'Gujurati'].map(lang => (
                                <Form.Check
                                    key={lang} type="checkbox" label={lang} name={lang.toLowerCase()}
                                    checked={formData.languages[lang.toLowerCase()]}
                                    onChange={(e) => handleInputChange(e, 'languages')}
                                    disabled={isViewOnly}
                                />
                            ))}
                        </div>
                    </Col>
                    <Col md={4}>
                        <Form.Label className="fw-semibold">Status</Form.Label>
                        <Form.Control value={formData.status} disabled />
                    </Col>
                </Row>

                {/* 2. Titles Row */}
                <Form.Label className="fw-semibold mb-2">Notification Titles</Form.Label>
                <Row className="g-3 mb-4">
                    {[
                        { label: 'English', key: 'english', count: stats?.users_english },
                        { label: 'Hindi', key: 'hindi', count: stats?.users_hindi },
                        { label: 'Marathi', key: 'marathi', count: stats?.users_marathi },
                        { label: 'Gujurati', key: 'gujurati', count: stats?.users_gujurati }
                    ].map(item => (
                        <Col md={3} key={item.key}>
                            <Form.Label className="small mb-1">{item.label} Title <span style={{ color: '#5662F6' }}>({item.count || 0})</span></Form.Label>
                            <Form.Control
                                value={formData.titles[item.key]}
                                disabled={isViewOnly || !formData.languages[item.key]}
                                onChange={(e) => handleInputChange(e, 'titles', item.key)}
                            />
                        </Col>
                    ))}
                </Row>

                {/* 3. Descriptions Row */}
                <Form.Label className="fw-semibold mb-2">Descriptions</Form.Label>
                <Row className="g-3 mb-4">
                    {['English', 'Hindi', 'Marathi', 'Gujurati'].map(lang => (
                        <Col md={6} key={lang}>
                            <Form.Label className="small mb-1">Description {lang}</Form.Label>
                            <Form.Control
                                as="textarea" rows={2}
                                value={formData.descriptions[lang.toLowerCase()]}
                                disabled={isViewOnly || !formData.languages[lang.toLowerCase()]}
                                onChange={(e) => handleInputChange(e, 'descriptions', lang.toLowerCase())}
                            />
                        </Col>
                    ))}
                </Row>

                {/* 4. Operations */}
                <Row className="g-3 mb-4">
                    <Col md={6}>
                        <Form.Label className="fw-semibold small mb-1">Action Link / URL</Form.Label>
                        <Form.Control name="action_link" value={formData.action_link} onChange={handleInputChange} disabled={isViewOnly} />
                    </Col>
                    <Col md={6}>
                        <Form.Label className="fw-semibold small mb-1">Thumbnail URL</Form.Label>
                        <Form.Control name="thumbnail_url" value={formData.thumbnail_url} onChange={handleInputChange} disabled={isViewOnly} />
                    </Col>
                </Row>

                {/* 5. Target Audience (Same Grid as Create) */}
                <Form.Label className="fw-semibold mb-2">Target Audience (Targeting {targetUser} users)</Form.Label>
                <Row className="mb-3">
                    <Col md={4}>
                        <Form.Check type="radio" label={`All Registered (${stats?.total_notifiable_users || 0})`} name="audience_selection" value="All" checked={formData.audience_selection === 'All'} disabled={isViewOnly} onChange={handleInputChange} />
                    </Col>
                    <Col md={4}>
                        <Form.Check type="radio" label="By Platform" name="audience_selection" value="Platform" checked={formData.audience_selection === 'Platform'} disabled={isViewOnly} onChange={handleInputChange} />
                        <div className="ms-4 mt-2">
                            <Form.Check type="checkbox" name="platform" value="iOS" label="iOS" checked={formData.platform_targets.includes('iOS')} disabled={isViewOnly || formData.audience_selection !== 'Platform'} onChange={handleInputChange} />
                            <Form.Check type="checkbox" name="platform" value="Android" label="Android" checked={formData.platform_targets.includes('Android')} disabled={isViewOnly || formData.audience_selection !== 'Platform'} onChange={handleInputChange} />
                        </div>
                    </Col>
                    <Col md={4}>
                        <Form.Check type="radio" label="By Activity" name="audience_selection" value="Activity" checked={formData.audience_selection === 'Activity'} disabled={isViewOnly} onChange={handleInputChange} />
                        <div className="ms-4 mt-2">
                            {['7', '30', '60'].map(days => (
                                <Form.Check key={days} type="radio" name="activity_range" value={days} label={`Last ${days} Days`} checked={formData.activity_range === days} disabled={isViewOnly || formData.audience_selection !== 'Activity'} onChange={handleInputChange} />
                            ))}
                        </div>
                    </Col>
                </Row>

                {/* 5a. By Favourite Entities — own row */}
                {(() => {
                    const isFav = formData.audience_selection === 'Favourite';
                    return (
                        <Row className="g-3 mb-4 align-items-start">
                            <Col md={2} className="pt-4">
                                <Form.Check
                                    type="radio"
                                    label="By Favourite Entities"
                                    name="audience_selection"
                                    value="Favourite"
                                    checked={isFav}
                                    disabled={isViewOnly}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small mb-1">Entity Type</Form.Label>
                                <Form.Select
                                    value={formData.favourite_entity_type}
                                    onChange={handleEntityTypeChange}
                                    disabled={isViewOnly || !isFav}
                                >
                                    <option value="">Select Entity</option>
                                    {ENTITY_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small mb-1">Search Entity</Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search entity..."
                                        value={entitySearchInput}
                                        onChange={handleEntitySearchChange}
                                        disabled={isViewOnly || !isFav || !formData.favourite_entity_type}
                                    />
                                    {isFav && formData.favourite_entity_type && entitySearchResults.length > 0 && (
                                        <div
                                            className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                            style={{ zIndex: 1000, maxHeight: 200, overflowY: 'auto' }}
                                        >
                                            {entitySearchResults.map(e => (
                                                <div
                                                    key={e.entity_id}
                                                    className="p-2"
                                                    style={{ cursor: 'pointer', fontSize: 14 }}
                                                    onMouseDown={(ev) => ev.preventDefault()}
                                                    onClick={() => handleEntitySelect(e)}
                                                >
                                                    {e.name} <span className="text-muted">({e.favourite_user_count ?? 0})</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small mb-1">Selected Entity</Form.Label>
                                <div
                                    style={{
                                        minHeight: 38, border: '1px solid #E2E8F0',
                                        borderRadius: 6, padding: '6px 10px', background: '#fff',
                                        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6
                                    }}
                                >
                                    {formData.favourite_entity_id ? (
                                        <span
                                            className="d-inline-flex align-items-center"
                                            style={{ background: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: 6, fontSize: 13 }}
                                        >
                                            {formData.favourite_entity_name || `ID: ${formData.favourite_entity_id}`}
                                            {!isViewOnly && (
                                                <button
                                                    type="button"
                                                    onClick={handleEntityRemove}
                                                    className="ms-2 border-0 bg-transparent text-white"
                                                    style={{ padding: 0, lineHeight: 1, fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }}
                                                >×</button>
                                            )}
                                        </span>
                                    ) : (
                                        <span className="text-muted small">No entity selected</span>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    );
                })()}

                {/* 6. Scheduling */}
                <Form.Check
                    type="checkbox" label="Auto Scheduling" className="fw-semibold mb-2"
                    checked={formData.isAutoScheduled} disabled={isViewOnly}
                    onChange={(e) => setFormData({ ...formData, isAutoScheduled: e.target.checked })}
                />
                <Row className="g-3 mb-4">
                    <Col md={3}>
                        <Form.Control type="date" name="scheduledDate" value={formData.scheduledDate} disabled={isViewOnly || !formData.isAutoScheduled} onChange={handleInputChange} />
                    </Col>
                    <Col md={3}>
                        <Form.Control type="time" name="scheduledTime" value={formData.scheduledTime} disabled={isViewOnly || !formData.isAutoScheduled} onChange={handleInputChange} />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="border-0 pb-4">
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                {!isViewOnly && <Button style={{ backgroundColor: '#5662F6', border: 'none' }} onClick={() => handleSubmit('Draft')} disabled={isLoading}>Update Draft</Button>}
                {!isViewOnly && <Button style={{ backgroundColor: '#5662F6', border: 'none' }} onClick={() => handleSubmit('Success')} disabled={isLoading}>Publish Now</Button>}
                <LogsReportModal show={showLogs} onHide={() => setShowLogs(false)} notificationId={templateData.id} />
            </Modal.Footer>
        </Modal>
    );
};

export default EditNotification;